export default __webpack_public_path__ + "d0edc8a520637f37a98adae34678b2a5.png";